import mapboxgl from 'mapbox-gl'
import Dropzone from 'dropzone'

I18n.defaultLocale = "fr";

mapboxgl.accessToken = "pk.eyJ1Ijoia29jaGthIiwiYSI6ImNqdTJyZzh6eDBlM200NGxsZzBpdTNyYmsifQ.bZUhTgm8VoQ0o5O99LVEUg";

Dropzone.autoDiscover = false;
